/**
 * We only show the avatar of the person on the last message in a
 * sequence of messages from the same user.
 **/
export default function shouldShowPlaceholderAvatar(index, messages) {
    const message = messages[index];
    const nextMessage = messages[index + 1];
    const nextMessageIsDifferentUser = nextMessage && nextMessage.sender.id !== message.sender.id;
    const isLastMessageInSequenceOfUser = !nextMessage || nextMessageIsDifferentUser;

    return !isLastMessageInSequenceOfUser;
}
